<template>
	<component :is="component" :feature="feature" v-if="component" />
</template>
<script>
export default {
	name: 'featureRow',
	props:{
		feature:Object
	},
	data() {
	  return {
	      component: null,
	  }
	},
	computed: {
	},
	mounted() {
		switch(this.feature.layer.id){
			case 'community-plans':
				this.component = () => import('../community-plan/community-plan-feature.vue');
				break;
			case 'overlays-visible':
				this.component = () => import('../overlay/overlay-feature.vue');
				break;
			case 'parcels':
				this.component = () => import('../parcel/parcel-feature.vue');
				break;
			case 'poi':
				// TODO: logic to break out different poi into different components
				this.component = () => import('../permit/permit-feature.vue');
				break;
			case 'sewer-mains':
				this.component = () => import('../sewer-main/sewer-main-feature.vue');
				break;
			case 'water-mains':
				this.component = () => import('../water-main/water-main-feature.vue');
				break;
			case 'zoning':
				this.component = () => import('../zoning/zoning-feature.vue');
				break;
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/components/feature/feature-row.vue